<div class="flex items-center justify-center">
  <div class="md:basis-3xl md:bg-white md:rounded-lg md:shadow-xl md:p-8">

    <h1 class="text-xl font-bold mb-8">Modulo di richiesta</h1>

    <form [formGroup]="requestForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6 form">

      <div>
        <select id="exercise-type" formControlName="exerciseTypeId">
          <option value="" disabled hidden>Seleziona il tipo di esercizio</option>
          <option *ngFor="let et of exerciseTypes" [ngValue]="et.id">
            {{et.label}}
          </option>
        </select>
      </div>

      <div>
        <label for="name">Nome</label>
        <input id="name" type="text" formControlName="name" />
      </div>

      <div>
        <label for="mail">Mail</label>
        <input id="mail" type="email" formControlName="mail" />
      </div>

      <div>
        <label for="request-type">Tipo di richiesta</label>
        <select id="request-type" formControlName="requestTypeId" (change)="onRequestTypeChange($event)">
          <option value="" disabled hidden>Seleziona il tipo richiesta</option>
          <option *ngFor="let rt of requestTypes" [value]="rt.id">
            {{rt.label}}
          </option>
        </select>
      </div>

      <div class="w-full bg-gray-300 p-2 rounded-md" *ngIf="requestTypeDescription.length>0">
        <div [innerHTML]="requestTypeDescription"></div>
      </div>

      <div>
        <label for="notes">Richiesta</label>
        <textarea id="notes" type="text" formControlName="notes" rows="10"></textarea>
      </div>

      <div>
        <label for="attachments">Allegati</label>
        <input type="file" id="attachments" multiple (change)="onFileSelected($event)"  formControlName="attachments" #fileInput/>
      </div>

      <div class="flex justify-end">
        <button type="submit" [disabled]="requestForm.invalid || submitted()"
                class="button">Invia</button>
      </div>

      <div>
        {{result}}
        <div>
          <button type="button" class="button" *ngIf="submitted()"
                  (click)="newRequest()">Nuova richiesta</button>
        </div>
      </div>

    </form>
  </div>
</div>
